<template>
  <div ref="pagantesChart" @update-charts="update" />
</template>

<script>
import ApexCharts from 'apexcharts';
import { i18n } from '@/modules/localization/index.js';
import eventbus from '@/modules/core/services/eventbus';
import estatisticasChartsDefaultOptions from './estatisticasChartsDefaultOptions';
export default {
  props: {
    loading: { type: Boolean, required: true },
  },
  data: () => ({
    pagantesChart: null,
    options: estatisticasChartsDefaultOptions,
  }),
  mounted() {
    this.pagantesChart = new ApexCharts(this.$refs.pagantesChart, this.options);
    this.pagantesChart.render();
    eventbus.on('update-charts', this.update);
  },
  unmounted() {
    this.pagantesChart.destroy();
    eventbus.off('update-charts', this.update);
  },
  methods: {
    async update(chartsData) {
      const x = chartsData.pagantes.map((x) => x.tipo);
      const y = chartsData.pagantes.map((x) => x.quantidade);
      this.pagantesChart.updateOptions({
        title: {
          text: i18n.global.t('pagantes'),
        },
        chart: {
          type: 'bar',
          height: 350,
        },
        series: [{ data: y }],
        xaxis: { categories: x },
      });
    },
  },
};
</script>
